module.exports = __webpack_public_path__ + "img/KM300.6b343745.png";